export default __webpack_public_path__ + "static/media/dot.470be0e5.csv";